import { axiosInstance } from "api/axios-config/axios-config";
import { BaseRequest } from "api/models/request/base-request";
import { Pagination } from "api/models/response/pagination";
import { IMaterialInventoryProperties } from "mobx-stores/_models/material-inventory/material-inventory";

class MaterialInventoryBussiness {
  readonly url = "/api/app/material-inventory";
  public getMaterialsInventory = async (request: BaseRequest) => {
    try {
      var res = await axiosInstance.get<
        Pagination<IMaterialInventoryProperties>
      >(this.url, {
        params: request,
      });
      return res.data;
    } catch (error) {
      console.error("Fail getMaterialsInventory", error);
      return Promise.reject(error);
    }
  };

  public getMaterialInventory = async (id: string) => {
    try {
      var res = await axiosInstance.get<IMaterialInventoryProperties>(
        `${this.url}/${id}`
      );
      return res.data;
    } catch (error) {
      console.error("Fail getMaterialInventory", error);
      return Promise.reject(error);
    }
  };
}

export const materialInventoryBussiness = new MaterialInventoryBussiness();
